import {
  GET_CANNED_DASHBOARDS,
  GET_AVAILABLE_DASHBOARDS_SHARED_WITH_ME,
  GET_USER_DASHBOARDS
} from 'hooks/useApi';

export default {
  canned: GET_CANNED_DASHBOARDS(),
  userDashboards: GET_USER_DASHBOARDS(),
  sharedDashboards: GET_AVAILABLE_DASHBOARDS_SHARED_WITH_ME()
};
